export default __webpack_public_path__ + "static/media/Ballroll_00362.3c087478.png";